import _ from 'lodash';
import { determineErrorFromResponse, isEpisode, isLive } from 'helpers/ContentHelper';
import { LIVE, VOD } from 'helpers/PlayerHelper';
import {
  CLEAR_BANNER_VIDEO,
  FETCH_BANNER_VIDEO_UP_NEXT,
  SET_BANNER_VIDEO_ERROR,
  SET_BANNER_VIDEO,
} from './Actions';

const INITIAL_STATE = {
  errors: null,
  nextVideos: [],
  releaseUrl: null,
  reducerVideo: null,
};

export default function(state = INITIAL_STATE, action) {
  const errors = determineErrorFromResponse(action);
  switch (action.type) {
    case CLEAR_BANNER_VIDEO: {
      return {
        ...state,
        ...INITIAL_STATE,
      };
    }
    case FETCH_BANNER_VIDEO_UP_NEXT: {
      const videos = _.get(action, 'payload.data.member', []);
      return {
        ...state,
        nextVideos: videos,
      };
    }
    case SET_BANNER_VIDEO_ERROR: {
      const newErrors = _.get(action, 'payload');
      if (!newErrors) return state;
      return {
        ...state,
        errors: newErrors,
      };
    }
    case SET_BANNER_VIDEO: {
      const data = _.get(action, 'payload');
      const videoType = _.get(data, 'videoType');
      const isFullEpisode = isEpisode(videoType);
      const videoIsLive = isLive(data);
      const videoFormat = videoIsLive ? LIVE : VOD;
      const reducerVideo = data ? { ...data, isFullEpisode, videoFormat } : null;
      const releaseUrl = _.get(reducerVideo, 'url', null);
      return {
        ...state,
        errors,
        nextVideos: [],
        reducerVideo,
        releaseUrl,
      };
    }
    default:
      return state;
  }
}
